import { useState, useEffect } from "react";
import {
  Typography,
  List,
  ListItem,
  ListItemText,
  Paper,
  Avatar,
  ListItemAvatar,
} from "@mui/material";

// Define the interface for the component props
interface FilePreviewProps {
  title?: string;
  files?: File[];
}

export default function FilePreview({
  title = "画像ファイルのプレビュー",
  files,
}: FilePreviewProps) {
  // State for file uploads
  const [uploadedFiles] = useState<File[]>(files || []);
  const [previewUrls, setPreviewUrls] = useState<string[]>([]);

  // Generate preview URLs when files change
  useEffect(() => {
    // Clean up previous URLs to avoid memory leaks
    previewUrls.forEach((url) => URL.revokeObjectURL(url));

    // Create new preview URLs
    const urls = uploadedFiles.map((file) => URL.createObjectURL(file));
    setPreviewUrls(urls);

    // Clean up function to release object URLs when component unmounts
    return () => {
      urls.forEach((url) => URL.revokeObjectURL(url));
    };
  }, [uploadedFiles]);

  // Display uploaded files
  return (
    <>
      <Typography variant="subtitle1" sx={{ mt: 2, mb: 1 }}>
        {title}
      </Typography>

      {/* Display uploaded files with previews */}
      {uploadedFiles.length > 0 && (
        <Paper variant="outlined" sx={{ mt: 2, p: 1 }}>
          <Typography variant="subtitle2" sx={{ mb: 1 }}>
            添付ファイル
          </Typography>
          <List dense>
            {uploadedFiles.map((file, index) => (
              <ListItem key={index}>
                <ListItemAvatar>
                  <Avatar
                    variant="rounded"
                    src={previewUrls[index]}
                    sx={{ width: 56, height: 56 }}
                    alt={`${file.name}のプレビュー`}
                  />
                </ListItemAvatar>
                <ListItemText
                  primary={file.name}
                  secondary={`${(file.size / (1024 * 1024)).toFixed(2)} MB`}
                  sx={{ ml: 1 }}
                />
              </ListItem>
            ))}
          </List>
        </Paper>
      )}
    </>
  );
}
